/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AjaxResponseOfListOfMentionUserDto } from "../models/AjaxResponseOfListOfMentionUserDto";
import type { AjaxResponseOfListOfTeamMilestoneApplicationLookupDto } from "../models/AjaxResponseOfListOfTeamMilestoneApplicationLookupDto";
import type { AjaxResponseOfListOfTeamMilestoneDto } from "../models/AjaxResponseOfListOfTeamMilestoneDto";
import type { AjaxResponseOfListOfTeamMilestoneTeamLookupDto } from "../models/AjaxResponseOfListOfTeamMilestoneTeamLookupDto";
import type { AjaxResponseOfMentionUserDetailDto } from "../models/AjaxResponseOfMentionUserDetailDto";
import type { AjaxResponseOfTeamMilestoneDto } from "../models/AjaxResponseOfTeamMilestoneDto";
import type { CreateTeamMilestoneDto } from "../models/CreateTeamMilestoneDto";
import type { UpdateTeamMilestoneDto } from "../models/UpdateTeamMilestoneDto";
import type { CancelablePromise } from "../core/CancelablePromise";
import type { BaseHttpRequest } from "../core/BaseHttpRequest";
export class TeamMilestoneAppService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * @returns AjaxResponseOfListOfTeamMilestoneDto Success
   * @throws ApiError
   */
  public getAll({
    teamId,
    applicationId,
    dateFrom,
    dateTo,
    isHighlighted,
    filter,
  }: {
    teamId: number;
    applicationId?: number;
    dateFrom?: string;
    dateTo?: string;
    isHighlighted?: boolean;
    filter?: string;
  }): CancelablePromise<AjaxResponseOfListOfTeamMilestoneDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/team-milestones",
      query: {
        teamId: teamId,
        applicationId: applicationId,
        dateFrom: dateFrom,
        dateTo: dateTo,
        isHighlighted: isHighlighted,
        filter: filter,
      },
    });
  }
  /**
   * @returns AjaxResponseOfTeamMilestoneDto Success
   * @throws ApiError
   */
  public update({
    requestBody,
  }: {
    requestBody?: UpdateTeamMilestoneDto;
  }): CancelablePromise<AjaxResponseOfTeamMilestoneDto> {
    return this.httpRequest.request({
      method: "PATCH",
      url: "/api/front-end/v1/team-milestones",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfTeamMilestoneDto Success
   * @throws ApiError
   */
  public create({
    requestBody,
  }: {
    requestBody?: CreateTeamMilestoneDto;
  }): CancelablePromise<AjaxResponseOfTeamMilestoneDto> {
    return this.httpRequest.request({
      method: "POST",
      url: "/api/front-end/v1/team-milestones",
      body: requestBody,
      mediaType: "application/json",
    });
  }
  /**
   * @returns AjaxResponseOfListOfMentionUserDto Success
   * @throws ApiError
   */
  public getMentionableUsers({
    teamId,
    filter,
  }: {
    teamId: number;
    filter?: string;
  }): CancelablePromise<AjaxResponseOfListOfMentionUserDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/team-milestones/mention-users",
      query: {
        teamId: teamId,
        filter: filter,
      },
    });
  }
  /**
   * @returns AjaxResponseOfMentionUserDetailDto Success
   * @throws ApiError
   */
  public getMentionUserDetail({
    userId,
    teamId,
  }: {
    userId: number;
    teamId?: number;
  }): CancelablePromise<AjaxResponseOfMentionUserDetailDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/team-milestones/mention-users/{userId}",
      path: {
        userId: userId,
      },
      query: {
        teamId: teamId,
      },
    });
  }
  /**
   * @returns AjaxResponseOfListOfTeamMilestoneTeamLookupDto Success
   * @throws ApiError
   */
  public getTeamsLookup({
    filter,
  }: {
    filter?: string;
  }): CancelablePromise<AjaxResponseOfListOfTeamMilestoneTeamLookupDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/team-milestones/teams-lookup",
      query: {
        filter: filter,
      },
    });
  }
  /**
   * @returns AjaxResponseOfListOfTeamMilestoneApplicationLookupDto Success
   * @throws ApiError
   */
  public getTeamApplicationsLookup({
    teamId,
  }: {
    teamId: number;
  }): CancelablePromise<AjaxResponseOfListOfTeamMilestoneApplicationLookupDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/team-milestones/teams/{teamId}/applications-lookup",
      path: {
        teamId: teamId,
      },
    });
  }
  /**
   * @returns any Success
   * @throws ApiError
   */
  public delete({ id }: { id: number }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: "DELETE",
      url: "/api/front-end/v1/team-milestones/{id}",
      path: {
        id: id,
      },
    });
  }
  /**
   * @returns AjaxResponseOfTeamMilestoneDto Success
   * @throws ApiError
   */
  public get({
    id,
  }: {
    id: number;
  }): CancelablePromise<AjaxResponseOfTeamMilestoneDto> {
    return this.httpRequest.request({
      method: "GET",
      url: "/api/front-end/v1/team-milestones/{id}",
      path: {
        id: id,
      },
    });
  }
}
